module.exports = /Win/.test(navigator.platform) ? '\r\n' : '\n';
